import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { id: "about", label: "Chi Sono" },
  { id: "services", label: "Servizi" },
  { id: "gallery", label: "Opere" },
  { id: "contact", label: "Contatti" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#FAF9F6]/85 border-b border-[#1A3628]/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-[92px] md:h-[112px] flex items-center justify-between">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="brand-link"
          className="flex items-center gap-3 text-left group"
        >
          <img
            src="/brand/verdea-logo.png"
            alt="VERDEA"
            className="h-20 md:h-28 w-auto object-contain transition-transform duration-500 group-hover:scale-[1.03]"
          />
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => go(n.id)}
              className="link-underline text-sm tracking-wide text-[#1A3628]/85 hover:text-[#1A3628]"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="hidden md:block">
          <button
            data-testid="header-cta"
            onClick={() => go("contact")}
            className="btn-primary !py-3 !px-6 !text-[0.7rem]"
          >
            Contattami
          </button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-[#1A3628]"
          aria-label="menu"
        >
          {open ? <X size={22} strokeWidth={1.5} /> : <Menu size={22} strokeWidth={1.5} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#FAF9F6] border-t border-[#1A3628]/10">
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`mobile-nav-${n.id}`}
                onClick={() => go(n.id)}
                className="text-left text-base text-[#1A3628] tracking-wide"
              >
                {n.label}
              </button>
            ))}
            <button
              data-testid="mobile-header-cta"
              onClick={() => go("contact")}
              className="btn-primary mt-2 self-start"
            >
              Contattami
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
